import { Link } from "react-router-dom";
import itdukesLogo from "@/assets/itdukes-logo.png";
import { ExternalLink, BookOpen, Shield } from "lucide-react";
import { analytics } from "@/hooks/useAnalytics";

export const Footer = () => {
  return (
    <footer className="border-t border-border bg-muted/30">
      <div className="page-container py-8 sm:py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-6">
          {/* Logo & Copyright */}
          <div className="flex flex-col items-center sm:items-start gap-3">
            <a href="https://itdukes.com" target="_blank" rel="noopener noreferrer" className="inline-block hover:opacity-80 transition-opacity">
              <img 
                src={itdukesLogo} 
                alt="IT Dukes" 
                width={71}
                height={20}
                className="h-5 w-auto"
              />
            </a>
            <p className="text-xs text-muted-foreground">
              © {new Date().getFullYear()} IT Dukes. All rights reserved.
            </p>
          </div>

          {/* Links */}
          <div className="flex items-center gap-6 text-sm">
            <Link 
              to="/glossary"
              className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition-colors"
            >
              <BookOpen className="w-3.5 h-3.5" />
              <span>Glossary</span>
            </Link>
            <Link 
              to="/privacy-policy"
              className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition-colors"
            >
              <Shield className="w-3.5 h-3.5" />
              <span>Privacy</span>
            </Link>
            <a 
              href="https://itdukes.com" 
              target="_blank" 
              rel="noopener noreferrer"
              onClick={() => analytics.externalLinkClicked("https://itdukes.com", "footer")}
              className="flex items-center gap-1.5 text-muted-foreground hover:text-foreground transition-colors"
            >
              <ExternalLink className="w-3.5 h-3.5" />
              <span>Visit Website</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
